import { Stack, Typography } from '@mui/material'
import {
  DashBoardConfigure,
  DashBoardItemOption,
  GraphItemType,
  GraphOptions
} from 'features/dashBoard/types'

import { GraphOptionAxisItem } from './axisItem'
import { GraphOptionValueItem } from './valueItem'
import { GraphOptionCheckItem } from './checkItem'
import { GraphOptionChoiceItem } from './choiceItem'
import { GraphOptionRankItem } from './rankItem'
import { GraphOptionNumericItem } from './numericItem'
import { GraphOptionTimeItem } from './timeItem'

import { TargetListResult } from "interface/search/targetList"

type GraphOptionProps<T> = {
  options: DashBoardItemOption[]
  readonly configure: DashBoardConfigure<T>
  graphType: GraphItemType
  setOptionValue: (id: string, value: string) => void
}
type GraphOptionLineProps<T> = {
  targetList?: TargetListResult
  line: GraphOptions[]
} & GraphOptionProps<T>
export const GraphOptionLine = <T,>({
  targetList,
  line,
  ...others
}: GraphOptionLineProps<T>) => {
  return (
    <Stack direction="row" spacing={1} alignItems="center">
      { line.map((option, j) => (
        <Stack key={`option-${j}`} direction="row" spacing={1} alignItems="center">
          { option.prefix && <Typography variant="body1">{option.prefix}</Typography> }

          { option.type === 'axis' ? <GraphOptionAxisItem option={option} targetList={targetList} {...others}/>
          : option.type === 'value' ? <GraphOptionValueItem option={option} targetList={targetList} {...others}/>
          : option.type === 'check' ? <GraphOptionCheckItem option={option} targetList={targetList} {...others}/>
          : option.type === 'choice' ? <GraphOptionChoiceItem option={option} targetList={targetList} {...others}/>
          : option.type === 'rank' ? <GraphOptionRankItem option={option} targetList={targetList} {...others}/>
          : option.type === 'numeric' ? <GraphOptionNumericItem option={option} targetList={targetList} {...others}/>
          : option.type === 'time' ? <GraphOptionTimeItem option={option} targetList={targetList} {...others}/>
          : <></> }

          {option.suffix && <Typography variant="body1">{option.suffix}</Typography> }
        </Stack>
      )) }
    </Stack>
  )
}